export default "__VITE_ASSET__WJ8drzZy__"